export default __webpack_public_path__ + "static/media/mus-coldblood.f7b7ea5a.mp4";